import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { ProjectPermissionDto } from 'projects/shared/src/lib/models/PermissionForCreationDto';
import { PermissionsService } from 'projects/shared/src/lib/services/permissions.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';

@Component({
  selector: 'project-permissions-list',
  templateUrl: './project-permissions-list.component.html',
  styleUrls: ['./project-permissions-list.component.css']
})

export class ProjectPermissionsListComponent implements OnInit {

  //@Input() actPlatformGroupRole!: PlatformGroupRoleDto;
  @Input() permissions: string = "";
  projectPermissions: ProjectPermissionDto[] = [];

  @Output() onChangeEvent: EventEmitter<string> = new EventEmitter();

  _tenantName!: string;

  constructor(
    private permissionService: PermissionsService,
    private tenantService: TenantService
    )
    { }


  ngOnInit(): void {
    // this.platformGroupRolePermissions = this.data.platformGroupRolePermissions;
    // this.actPlatformGroupRole = this.data.platformGroupRole;
    console.log("--------> project-permissions-list")
    console.log(this.permissions)

    // this._tenantName = localStorage.getItem('current-tenant-name') as string;
    this._tenantName = this.tenantService.currentTenantName;
    this.mapTenantPermissions()
  }

  mapTenantPermissions() {
    // all possible permissions
    this.permissionService.loadProjectPermissions(this._tenantName, new GenericFilter()).subscribe({
      next:(permissionDtos:any) => { 
        this.projectPermissions = permissionDtos;
        if (this.permissions) {
          console.log("project permissions:", this.permissions)
          let permArrayRole = this.permissions.split(",");
          let permArrayPlatform = this.projectPermissions;
          permArrayPlatform.forEach(function (platformPerm) {
            permArrayRole.forEach(function (rolePerm) {
              if (rolePerm == platformPerm.name) platformPerm.permissionValue = true;
            })
          }) 
        }
      }
    })
  }

  onChange() {
    this.onChangeEvent.emit(this.mapRolePermissions());
  }

  mapRolePermissions() : string{
    this.permissions = "";
    let permArrayPlatform = this.projectPermissions;
    let newPerms = "";
    permArrayPlatform.forEach(function (platformPerm) {
      if (newPerms != "" && platformPerm.permissionValue) newPerms += ",";
      if (platformPerm.permissionValue) newPerms += platformPerm.name;
    }) 
    this.permissions = newPerms;
    return newPerms
  }
}
